// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoPlayer_wrapper__ZC2G5","wistia_embed":"VideoPlayer_wistia_embed__pVtog"};